import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=1645542e"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"
import style0 from "./reset.vue?vue&type=style&index=0&id=1645542e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports